import { CourseSurveyAnswer } from './course-survey-answer';
import { CourseSurveyQuestion } from './course-survey-question';
import { Step } from './step';

export class CourseStepSurvey extends Step {
  public questions?: CourseSurveyQuestion[];
  public answers?: CourseSurveyAnswer[];
}
